import React from 'react';
import BandMembers from '../BandMembersList/BandMembers/BandMembers';
import { BandMembersEpoch } from '../Band.interface';
import { environments } from 'environments/environments';

export default class SingleBandMembersEpoch extends React.Component {
  state = {
    epoch: {} as BandMembersEpoch
  }

  componentDidMount() {
    this.getSingleBandMembersEpoch();
  }

  getSingleBandMembersEpoch() {
    fetch(environments.server + '/data/band_members_epochs.json', { cache: 'no-cache' })
      .then(async response => {
        const data: BandMembersEpoch[] = await response.json();
        const bandMembersEpochs = data.find(epoch => '' + epoch.id === '' + (this.props as any).match.params.epoch) || data[0];
        this.setState({ epoch: bandMembersEpochs });
      })
      // TODO: Display error message to user when data not loaded
      .catch(e => console.error('Složení kapely nebylo řádně načteno.\n', e));
  }

  render() {
    return (
      <div>
        {this.state.epoch && this.state.epoch.id
          ? <BandMembers bandMembers={this.state.epoch} listed={false} />
          : null
        }
      </div>
    );
  }
}